import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ standalone: false, name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(public sanitized: DomSanitizer) {}
  transform(value: string): SafeHtml {
    const clean = this.sanitized.sanitize(SecurityContext.HTML, value) ?? '';
    return this.sanitized.bypassSecurityTrustHtml(clean);
    }
}
